module.exports = __webpack_public_path__ + "img/Pic_Loading.efba4752.jpg";